import { FC } from 'react';
import { ItemList } from '@app/form_components';
import { FormControlProps, ModuleOutput } from '@app/types';
import { ModuleOutputForm, ModuleOutputFormProps } from './ModuleOutputForm';

export type ModuleOutputsFormProps = (
  FormControlProps<ModuleOutput[]>
  & Pick<ModuleOutputFormProps, 'moduleId'>
);

export const ModuleOutputsForm: FC<ModuleOutputsFormProps> = ({
  moduleId,
  ...listProps
}) => {
  const labels = window.l.property;

  return (
    <ItemList<ModuleOutput>
      {...listProps}
      getKey={(output) => output.id}
      label={labels.outputs}
      renderForm={(props) => <ModuleOutputForm {...props} moduleId={moduleId} />}
      renderRow={({ value }) => {
        return (
          <>
            <h4>To: {value.varName}</h4>
            <div className='subtext'>From: {value.argumentName}</div>
          </>
        );
      }}
      tooltip={labels.outputsTooltip}
    />
  );
};
